import { getGlobal, setGlobal } from '../../global';

import { APP_CODE_NAME, INTERCLIENT_BROADCAST_CHANNEL } from '../../config';
import { updateTabState } from '../../global/reducers/tabs';
import { selectTabState } from '../../global/selectors';
import { createSafeBroadcastChannel } from '../safeBroadcastChannel';

export default function listenOtherClients() {
  const channel = createSafeBroadcastChannel(INTERCLIENT_BROADCAST_CHANNEL);
  if (!channel) {
    return;
  }

  channel.addEventListener('message', (event) => {
    if (event.data !== APP_CODE_NAME) {
      let global = getGlobal();
      const tabState = selectTabState(global);
      global = updateTabState(global, {
        inactiveReason: 'otherClient',
      }, tabState.id);
      setGlobal(global);
    }
  });

  channel.postMessage(APP_CODE_NAME);
}
